import {
    apiSearch, 
    searchRef,
    defaultLimit
} from './module_api_search'

function showNextPage(){
    const container = searchRef.searchResults;
    if(!container.length) return;
    const elements = container.find(searchRef.cardContainerClass);
    apiSearch(defaultLimit, elements.length);
}

export function attachShowNextPageListener(){
    const el = document.querySelector('#showmorebtn')
    if (el === null) return
    el.addEventListener('click', () => {
        showNextPage()
    })
}
